import React from 'react';
import './InputFormsForQuizes.scss';
import { closeInputForms, idCategoriesCreate } from '../../../adminSlice';

export default class AddInputFormsForCategories  extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            userInputId: '',
            userInputContent: '',
                     
        }
      
       this.handleUserInputContent = this.handleUserInputContent.bind(this);
       this.handleUserInputId = this.handleUserInputId.bind(this);
       
       this.onSend = this.onSend.bind(this);
       this.onClose = this.onClose.bind(this);
    }

  
 // CLICK OK
onSend() {
        const { dispatch } = this.props;

        const item = {
           
            main_id: this.state.userInputId,
            main_name: this.state.userInputContent
            
        }
        console.log(item);
        dispatch(idCategoriesCreate(item));  
}
// ENTER INPUT
handleUserInputContent(e) {
    this.setState(
        {
            userInputContent: e.target.value
        }
    )
}
handleUserInputId(e) {
    this.setState(
        {
            userInputId: e.target.value
        }
    )
}



// CLOSE FORM
onClose() {
    const { dispatch } = this.props;
    dispatch(closeInputForms());

}

   renderTable() {
       return null;
   }
   
    render() {
        //console.log(this.props.adminState.openInputForms);
     if (this.props.adminState.openAddInputFormsForCategories) {
        return(
            <div className="InputFormsForQuizes">
                           


             <p>Создать новую категорию:</p>
             <form>
             <label>
                     Введите номер категории: </label>
                 <input id="idCat" type="number"  onChange={this.handleUserInputId} 
                 />
                 
                 <label>
                     Введите название:</label>
                 <input id="content" type="text"  onChange={this.handleUserInputContent} 
                 />
                 


             </form>
             <button onClick={this.onSend}>OK</button>
             <button onClick={this.onClose}>Отмена</button>
            </div>
        )
     } else return null;
       
     

        
    }
}
